import { Suspense } from 'react';

import { Routes, Route } from 'react-router-dom';
import { Error, Loading } from 'pages';
import { toastError } from 'ui/partials/Toast';

import { PublicRoutes as _PublicRoutes } from './Routes';

export const ErrorPage = () => {
  toastError('Public Page Invalid.');

  setTimeout(() => {
    window.location.href = '/login';
  }, 2000);

  return <Error />;
};

const PublicRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Routes>
      {_PublicRoutes.map(({ path, element, index }) => (
        <Route
          key={Math.random()}
          path={path}
          index={Boolean(index)}
          element={element?.()}
        />
      ))}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  </Suspense>
);

export default PublicRoutes;

export const PublicRoutesWrapper = () => (
  <div className="absolute z-[999999] top-0 left-0 w-full">
    <PublicRoutes />
  </div>
);
